<template>
    <div>
        <div class="bg-white border rounded-lg p-2">
            <div class="p-2 d-flex align-items-center justify-content-between">
                <span class="quantity-label fw-bold">How many tyres do you need?</span>
                <select name="quantity" id="quantity" class="form-select" v-model="quantity">
                    <option v-for="index in 5" :key="index" :value="index">{{ index }} tyre{{ index > 1 ? 's' : '' }}</option>
                </select>
            </div>
            <hr class="my-2">
            <div class="p-2 d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center gap-3">
                    <b class="price">&pound;{{ tyre.fully_fitted_price }}</b>
                    <div class="d-flex">
                        <b>Fully fitted</b>
                        <route-tooltip :home-delivery="false" class="ms-1"></route-tooltip>
                    </div>
                </div>
                <div class="col-4">
                    <button
                        class="btn btn-primary ms-auto d-block"
                        @click="this.changeRouteAddToBasket(tyre.st_code, 0)"
                        v-if="parseInt(tyreStock.total_stock) >= minimumStockRequired"
                    >
                        Buy now
                    </button>
                    <div v-else>
                        <p class="mb-0 text-center">Out of stock</p>
                    </div>
                </div>
            </div>
            <hr class="my-2" v-if="showHomeDeliveryPrices">
            <div
                v-if="showHomeDeliveryPrices"
                class="p-2 d-flex align-items-center justify-content-between"
            >
                <div class="d-flex align-items-center gap-3">
                    <b class="price">&pound;{{ tyre.home_delivery_price }}</b>
                    <div class="d-flex">
                        <b>Tyre delivery</b>
                        <route-tooltip :home-delivery="true" class="ms-1"></route-tooltip>
                    </div>
                </div>
                <div class="col-4">
                    <button
                        class="btn btn-primary ms-auto d-block"
                        @click="this.changeRouteAddToBasket(tyre.st_code, 1)"
                        v-if="parseInt(tyreStock.home_delivery_stock) >= minimumStockRequired"
                    >
                        Buy now
                    </button>
                    <div v-else>
                        <p class="mb-0 text-center">Out of stock</p>
                    </div>
                </div>
            </div>
            <template v-if="showPaypal">
                <div v-if="updatedPaypalPrice >= 30"
                    class="bg-secondary px-3 py-2 mt-3 mb-1 rounded d-none d-sm-block"
                    data-pp-style-logo-position="top" data-pp-message :data-pp-amount="updatedPaypalPrice"
                    data-pp-placement="product" data-pp-style-layout="text" data-pp-style-text-size="16"
                    data-pp-style-text-color="white"></div>
                <div v-if="updatedPaypalPrice >= 30"
                    class="bg-secondary px-3 py-2 mb-3 mt-2 mt-sm-0 rounded d-block d-sm-none"
                    data-pp-style-logo-position="top" data-pp-message data-pp-placement="category"
                    data-pp-style-layout="text" data-pp-style-text-size="12" data-pp-style-text-color="white"></div>
            </template>
        </div>
        <br>
        <teleport to="body">
            <basket-modal :postcode="postcode" :basket="updatedBasket" :modal-open="modalOpen"
                @closeModal="modalOpen = false" @basketUpdated="basketUpdated"></basket-modal>
            <upsell-modal :current-tyre="currentTyre" :upsold-tyre="upsoldTyre" :upsell-details="upsellDetails"
                :upsell-modal-open="upsellModalOpen" :image-base-path="tyreImagePath"
                @closeModal="upsellModalOpen = false"></upsell-modal>
            <info-modal></info-modal>
        </teleport>
    </div>
</template>

<script>
    import basket from '@shared/mixins/basket';

    export default {
        props: [
            'brandDetails',
            'tyre',
            'homeDeliverySession',
            'basket',
            'sizeOptions',
            'banners',
            'showPaypal',
            'tyreImagePath',
            'brandImagePath',
            'ppPrice',
            'postcode',
            'tyreStock',
            'minimumStockRequired',
            'showHomeDeliveryPrices',
        ],
        emits: ['basket-updated', 'modalOpen'],
        mixins: [basket],
        data() {
            return {
	            updatedBasket: this.basket,
                homeDelivery: (this.homeDeliverySession == 1 ? true : false),
	            modalOpen: false
            }
        },
        mounted() {
			//removes loading placeholder - fixes CLS issues
            if (document.contains(document.querySelector('#loadingPlaceholder'))) {
			    document.querySelector('#loadingPlaceholder').style.display = 'none';
            }

            if(typeof(this.$gtag) !== 'undefined') {
                this.$gtag.event('view_item', {
                    currency: "GBP",
                    value: this.tyre.retail,
                    items: [
                        {
                            "item_id": this.tyre['st_code'],
                            "item_brand" : this.tyre['brand'],
                            "item_name" : this.tyre['description'],
                            "price": this.tyre['retail'],
                            "quantity": 1
                        }
                    ]
                });
            }
            else {
                console.log('gtag not loaded');
            }
        },
        methods: {
	        openModal() {
	        	this.modalOpen = true;
	        },
	        basketUpdated: function(data) {
	        	this.updatedBasket = data;
			},
            async changeRouteAddToBasket(st_code, homeDelivery) {
                var response = await axios.post('/ajax/toggle_home_delivery_route/' + homeDelivery);

                this.addTyreToBasket(st_code, this.quantity);
            }
        },
        computed: {
            bannerBackgroundStyle() {
                var bannerUrl = typeof(this.banners[0]) != 'undefined' ? this.banners[0].brand_mobile_image_url : null;
                var object = 'background: url(' + (bannerUrl) + ') no-repeat; background-size: cover; background-position: center center;';
                
                return object;
            },
            updatedPaypalPrice() {
                return this.quantity * this.ppPrice;
            }
        }
    }
</script>

<style lang="scss" scoped>
    #quantity {
        max-width: 100px;
    }
    .price {
        font-size: 25px;
    }
    .route-type {
        font-size: 16px;
    }
</style>